import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/Auth';
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Spinner from 'react-bootstrap/Spinner'
import Badge from 'react-bootstrap/Badge'
import changeDateFormat from './utils.js'
import { supabase } from "../utils/supabaseClient"
import { useAlert } from 'react-alert'
import { ChatLeftDots, Trash } from 'react-bootstrap-icons';
import commentStyles from '../styles/Comment.module.css'


export default function Comments(props) {
  const { user } = useAuth();
  const [ formText, setFormText] = useState('')
  const [comments, setComments] = useState([])
  const [reply, setReply] = useState([])
  const customAlert = useAlert()




  //recursively grab all comments
  const grabComments = (data, newComments, cId) => {
      let replies = data.filter(obj=> {
          if (obj.reply) {
            return obj.reply.id === cId
          } else {
            return null
          }
        })
      for (var j = 0; j < replies.length; j++) {
        newComments.push(replies[j])
        const currentId = replies[j].id
        const checkReplies = data.filter(obj=> {
           if (obj.reply) {
            return obj.reply.id === currentId
          } else {
            return null
          }
        })
        if (checkReplies.length > 0) {
          grabComments(data, newComments, currentId)
        }
      }
      return
  }

  const fetchMyAPI = async () => {
      const { data, error } = await supabase
          .from("main_comment")
          .select(`
            id,
            post,
            date,
            reply (
              id,
              profile (
                username
              )
            ),
            profile (
              id,
              username,
              user,
              is_superuser
            )
          `)
          .filter(props.type, "eq", props.parent_id)
          .order('date', { ascending: false })
        
      let cleanedComments = data.filter(obj => obj.reply === null)
      let newComments = []

      for (var i = 0; i < cleanedComments.length; i++) {
        const comm = cleanedComments[i]
        newComments.push(comm)
        grabComments(data, newComments, comm.id)
      }
      setComments(newComments)
  }



  useEffect(() => {
      fetchMyAPI()
  }, [])


  const replyComment = async (e, id, username) => {
    setReply([id, username])
    window.location.href = "#form_comment";
  }

  const deleteComment = async (e, cId) => {

     const {data, error} = await supabase
        .from('main_comment')
        .delete()
        .match({id:cId})

    if (error) {
      const {data, error} = await supabase
        .from('main_comment')
        .update({post: 'Deleted'})
        .match({id:cId})
    }
     fetchMyAPI()
  }

  const handleSubmit = async (e) => {
        e.preventDefault()
        const text = e.target[0].value

        if (text.length < 1) {
          customAlert.error("Please enter a comment.")
          return
        }
        if (text.length > 250) {
          customAlert.error("Please leave a comment less than 250 characters.")
          return
        }

        const {data:profile, error1} = await supabase
          .from('main_profile')
          .select('id, user')
          .filter('user','eq',user.id)

        //send fetch request to post data to backend
        let commentData = {
          'post':text,
          'profile':profile[0].id,
          [props.type]:props.parent_id,
        } 

        if (reply.length > 1) {
          commentData["reply"] = reply[0]
        }

        const {data, error} = await supabase
          .from('main_comment')
          .insert([
            commentData
          ])
          fetchMyAPI()
          setFormText('')
          setReply([])
  }

  if (!comments) return <Spinner animation="border" role="status">
    <span className="visually-hidden">Loading...</span>
    </Spinner>

  return (
    <div id="form_comment">
      <div>
        <p className="text-muted"> 
        {reply.length < 2 ?
          <span className="text-dark  text-uppercase fw-bold" id="comment_title">Post a Comment</span>
        : 
          <span className="text-dark  text-uppercase" id="comment_title">Reply to {reply[1]}</span>
        }
            <br/>
            Join the community
        </p>
      </div>

      <Form validated={false} onSubmit={(e) => handleSubmit(e)}>
          <Form.Group className="mb-3">
              <Form.Control onChange={(e)=>setFormText(e.target.value)} value={formText} as="textarea" rows={4}/>
  
          </Form.Group>
  
        <div className="d-flex">
        { user ? 
          <Button className="ms-auto mb-5" type="submit" id="comment_btn" variant="purple" size="sm">Comment</Button>
          :
          //add register popup
          <Button className="ms-auto mb-5" variant="purple" size="sm" onClick={props.handleRegisterModal}>Comment</Button>
        }
        </div>
      </Form>


      {comments.map((obj)=> (
        <div key={obj.id}>
        
         {obj.reply ? 
         <>
          {/* Replies */}
          {/* <hr/> */}
          <div className="text-muted ps-5" key={obj.id}>
          

            
              {obj.profile.is_superuser ? 
              <>
                <span className="h6 my-auto text-purple">{obj.profile.username}</span> <Badge bg="purple">Admin</Badge>
                <span className="text-muted ps-2"><small>replied to {obj.reply.profile.username}</small></span>
              </>
              :
              <>
                <span className="h6 my-auto text-purple" >{obj.profile.username}</span>
                <span className="text-muted ps-2"><small>replied to {obj.reply.profile.username}</small></span>
              </>
              }

                {/* style="font-size:14px" */}
              <span className="text-muted px-2"><small>{ changeDateFormat(obj.date) }</small></span>
              <br/>

              <p className="text-dark mb-2"><small>{ obj.post }</small></p>

              {user ?
              
                  user.id === obj.profile.user ?
                  // "font-size:12px; color:#ED2939"
                  
                  <div className="d-flex justify-content-end pb-3">
                    <Button size="sm" variant="link" className={commentStyles.reply} onClick={(e) => deleteComment(e, obj.id)}><Trash /> Delete</Button>{' '}
                    <Button size="sm" variant="link" className={commentStyles.reply} onClick={(e) => replyComment(e,obj.id,obj.profile.username)}><ChatLeftDots /> Reply</Button>
                  </div>
                    :
                  
                  <div className="d-flex justify-content-end pb-3">
                    <Button size="sm" variant="link" className={commentStyles.reply} onClick={(e) => replyComment(e,obj.id,obj.profile.username)}><ChatLeftDots /> Reply</Button>
                  </div>
              :
                    // Needs to add popup register modal
                  <div className="d-flex justify-content-end  pb-3">
                    <Button size="sm" variant="link" className={commentStyles.reply} onClick={props.handleRegisterModal} ><ChatLeftDots /> Reply</Button>
                  </div>
           
              }

            </div>
            {/* end replies */}
          </>

          :
          <div className="text-muted pt-4" key={obj.id}  style={{borderTop:'1px solid rgb(128,128,128, 0.15)'}}>
          
              {obj.profile.is_superuser ? 
              <>
                <span className="h6 my-auto text-purple ps-2">{obj.profile.username}</span> <Badge bg="purple">Admin</Badge>
              </>
              :
              <>
                <span className="h6 my-auto text-purple ps-2">{obj.profile.username}</span>
              </>
              }

                {/* style="font-size:14px" */}
              <span className="text-muted px-2"><small>{ changeDateFormat(obj.date) }</small></span>
              <br/>

              <p className="text-dark ps-2 mb-2 "><small>{ obj.post }</small></p>

              {user ?
              
                  user.id === obj.profile.user ?
                  // "font-size:12px; color:#ED2939"
                  
                    <div className="d-flex justify-content-end pb-3">
                      <Button size="sm" variant="link"  className={commentStyles.reply} onClick={(e) => deleteComment(e, obj.id)}><Trash /> Delete</Button>{' '}
                      <Button size="sm"  variant="link" className={commentStyles.reply} onClick={(e) => replyComment(e,obj.id,obj.profile.username)}><ChatLeftDots /> Reply</Button>
                    </div>
                    :
                    <div className="d-flex justify-content-end pb-3">
                      <Button size="sm" variant="link" className={commentStyles.reply} onClick={(e) => replyComment(e,obj.id,obj.profile.username)}><ChatLeftDots /> Reply</Button>
                    </div>
              :
                  
                <div className="d-flex justify-content-end pb-3">
                  <Button size="sm" variant="link" className={commentStyles.reply} onClick={props.handleRegisterModal}><ChatLeftDots /> Reply</Button>
                </div>
         
              }


            </div>
  
          }
        </div>

            
      ))}
      
    </div>
  )


}
